"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Details = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactQuery = require("react-query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _mapping = require("@nicbase/mapping");

var _request = require("@nicbase/request");

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _information = _interopRequireDefault(require("./information"));

var _loading = _interopRequireDefault(require("./loading"));

var _monitoring = _interopRequireDefault(require("./monitoring"));

var _procedure = _interopRequireDefault(require("./procedure"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getCoupledAssets = function getCoupledAssets(_ref) {
  var portalId = _ref.portalId,
      id = _ref.id,
      assignedFrom = _ref.assignedFrom,
      assignedUntil = _ref.assignedUntil;
  return {
    type: 'GET_COUPLED_ASSET_REQUEST',
    headers: {
      version: 'v3',
      portalId: portalId
    },
    body: {
      asset: {
        id: id,
        assignedFrom: assignedFrom,
        assignedUntil: assignedUntil
      }
    }
  };
};

var Details = function Details(_ref2) {
  var _tour$additionalData, _tour$additionalData$;

  var tour = _ref2.tour,
      portalId = _ref2.portalId,
      isActive = _ref2.isActive,
      onCancel = _ref2.onCancel;
  var isEtaMonitoringEnabled = tour.etaProvider !== null;
  var areAlarmsEnabled = tour.alarms && tour.alarms.length > 0;
  var isDelayedAlarmsEnabled = tour.delayedStartLimitAlarm !== null || tour.delayedEndLimitAlarm !== null;
  var isStartStopAlarmsEnabled = tour.startStopAlarmsEnabled === true;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var user = (0, _nicbaseReducers.useUser)(); // poi information list

  var _usePortalPois = (0, _hooks.usePortalPois)(portalId, null),
      _usePortalPois$data = _usePortalPois.data,
      pois = _usePortalPois$data === void 0 ? [] : _usePortalPois$data;

  var assetId = tour.assetId,
      assetName = tour.assetName,
      assetType = tour.assetType;

  var _useQuery = (0, _reactQuery.useQuery)([].concat(_toConsumableArray(_hooks.queryKeys.portal.all(portalId)), ['coupledAssets', {
    assetId: tour.assetId,
    realStartTime: tour.realStartTime,
    realEndTime: tour.realEndTime
  }]), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request(getCoupledAssets({
              portalId: portalId,
              id: tour.assetId,
              assignedFrom: tour.realStartTime ? tour.realStartTime : new Date(Date.now()),
              assignedUntil: tour.realEndTime ? tour.realEndTime : new Date(Date.now())
            }));

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.body.asset);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), {
    enabled: isActive && (0, _mapping.isCoupledAsset)(tour.assetType)
  }),
      _useQuery$data = _useQuery.data,
      train = _useQuery$data === void 0 ? {
    id: assetId,
    name: assetName,
    type: assetType,
    coupledAssets: [{
      id: assetId,
      name: assetName,
      type: assetType
    }]
  } : _useQuery$data,
      isLoadingCoupledAssets = _useQuery.isLoading;

  var showCommonInformations = (tour === null || tour === void 0 ? void 0 : tour.name) || (tour === null || tour === void 0 ? void 0 : tour.externalId);
  var showProcedures = tour === null || tour === void 0 ? void 0 : tour.wayPoints;
  var showLoadings = (tour === null || tour === void 0 ? void 0 : (_tour$additionalData = tour.additionalData) === null || _tour$additionalData === void 0 ? void 0 : (_tour$additionalData$ = _tour$additionalData.railInfo) === null || _tour$additionalData$ === void 0 ? void 0 : _tour$additionalData$.wagonLoadings) || assetName;
  var showMonitoring = isEtaMonitoringEnabled || areAlarmsEnabled || isDelayedAlarmsEnabled || isStartStopAlarmsEnabled;
  return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.BasisDialog, {
    active: isActive,
    title: intl.formatMessage({
      id: 'widgets.tourBoard.details'
    }),
    content: /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-96 flex flex-col"
    }, showCommonInformations && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
      title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.details.information",
        tagName: "span"
      })
    }, /*#__PURE__*/_react["default"].createElement(_information["default"], {
      tour: tour,
      user: user
    })), showProcedures && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
      title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.details.procedure",
        tagName: "span"
      })
    }, /*#__PURE__*/_react["default"].createElement(_procedure["default"], {
      tour: tour,
      user: user,
      pois: pois
    })), showLoadings && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
      title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.details.loading",
        tagName: "span"
      })
    }, /*#__PURE__*/_react["default"].createElement(_loading["default"], {
      tour: tour,
      train: train,
      isLoadingCoupledAssets: isLoadingCoupledAssets
    })), showMonitoring && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
      title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.details.monitoring",
        tagName: "span"
      })
    }, /*#__PURE__*/_react["default"].createElement(_monitoring["default"], {
      tour: tour,
      user: user
    }))),
    actions: /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      primary: true,
      raised: true,
      className: "action-button cancel-button",
      onClick: onCancel
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.ok",
      tagName: "span"
    })),
    onRequestCancel: onCancel,
    onRequestClose: onCancel
  });
};

exports.Details = Details;
Details.propTypes = {
  portalId: _propTypes["default"].number.isRequired,
  isActive: _propTypes["default"].bool.isRequired,
  onCancel: _propTypes["default"].func,
  tour: _propTypes["default"].shape({
    assetId: _propTypes["default"].string,
    assetName: _propTypes["default"].string,
    assetType: _propTypes["default"].number,
    name: _propTypes["default"].string,
    externalId: _propTypes["default"].string,
    realStartTime: _propTypes["default"].string,
    realEndTime: _propTypes["default"].string,
    alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired,
      type: _propTypes["default"].string
    })),
    wayPoints: _propTypes["default"].shape(),
    etaProvider: _propTypes["default"].string,
    delayedStartLimitAlarm: _propTypes["default"].string,
    delayedEndLimitAlarm: _propTypes["default"].string,
    startStopAlarmsEnabled: _propTypes["default"].bool,
    additionalData: _propTypes["default"].shape({
      railInfo: _propTypes["default"].shape({
        wagonLoadings: _propTypes["default"].arrayOf(_propTypes["default"].shape())
      })
    })
  }).isRequired
};

var noop = function noop() {};

Details.defaultProps = {
  onCancel: noop
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(Details);

exports["default"] = _default;